import { UUID } from '@macs-frontend/core/utils/uuid';

export interface BaseExpenseGroup {
  uuid: null | UUID;
  name: string;
  expenseUnitPrice: null | number;
  billableRate: null | number;
  description: string;
  groupByType: null | string;
  status: null | string;
}

export interface Expense extends BaseExpense {
  expenseGroups: BaseExpenseGroup[];
}

export interface ExpenseGroup extends BaseExpenseGroup {
  expenses: Expense[];
  type: null | {
    uuid: null | UUID;
    name: null | string;
  };
}

export enum ExpenseStatuses {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface BaseExpense {
  uuid: null | UUID;
  name: string;
  expenseUnitPrice: null | number;
  status: ExpenseStatuses;
  billableRate: null | number;
  description: null | string;
  groupByType: null | string;
}
